<template>
  <div>
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          @keydown.esc="avisoCerrar"
          persistent
        >
          <v-card tile>
            <v-toolbar
              flat
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="avisoCerrar"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                <span v-if="!editandoUsuario && !usuario.name && !usuario.apellidos">
                  Nuevo Usuario
                </span>
                <span>
                  {{ usuario.name }} {{ usuario.apellidos }}
                </span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="guardar"
                  :disabled="$v.passconfirm.$invalid || $v.usuario.$invalid"
                >
                  Guardar
                </v-btn>
              </v-toolbar-items>
              <v-menu
                bottom
                right
                offset-y
              >
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-expansion-panels
                v-model="panel"
                multiple
              >
                <v-expansion-panel class="mt-4">
                  <v-expansion-panel-header class="text-h6">Información Básica</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters>
                      <v-col cols="12" sm="2" md="2" class="align-self-center d-flex justify-center">
                        <v-avatar
                          :color="usuario.color"
                          size="56"
                        >
                          <span class="white--text headline">
                            {{ usuario.avatar }}
                          </span>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" sm="10" md="10">
                        <v-row>
                          <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field
                              v-model="usuario.name"
                              v-on:input="setAvatar()"
                              label="Nombre"
                              prepend-icon="mdi-account-outline"
                              :error-messages="errorNombre"
                              @input="$v.usuario.name.$touch()"
                              @blur="$v.usuario.name.$touch()"
                              required
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="8" md="8" class="pt-0 pb-0">
                            <v-text-field
                              v-model="usuario.apellidos"
                              v-on:input="setAvatar()"
                              label="Apellidos"
                              :error-messages="errorApellido"
                              @input="$v.usuario.apellidos.$touch()"
                              @blur="$v.usuario.apellidos.$touch()"
                              required
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-0 pb-0">
                              <v-text-field
                                v-model="usuario.email"
                                label="Email"
                                prepend-icon="mdi-email-outline"
                                :error-messages="errorEmail"
                                @input="$v.usuario.email.$touch()"
                                @blur="$v.usuario.email.$touch()"
                                :disabled="editandoUsuario"
                                class="anadirAsterisco"
                              ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="editandoUsuario">
                          <v-btn
                            color="warning"
                            class="ma-2"
                            outlined
                            v-if="!resetPassword"
                            @click="resetPassword = !resetPassword"
                          >
                          <v-icon
                              left
                              dark
                            >
                              mdi-key-outline
                            </v-icon>
                            Restablecer contraseña
                          </v-btn>
                        </v-row>
                        <v-row v-if="!editandoUsuario || resetPassword">
                          <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="usuario.password"
                              prepend-icon="mdi-key-outline"
                              :error-messages="errorPassword"
                              @input="$v.usuario.password.$touch()"
                              @blur="$v.usuario.password.$touch()"
                              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPass ? 'text' : 'password'"
                              name="password"
                              label="Contraseña"
                              hint="Letras, números y mayúsculas"
                              counter
                              @click:append="showPass = !showPass"
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="passconfirm"
                              :append-icon="showPassConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                              :error-messages="errorPassconfirm"
                              @input="$v.passconfirm.$touch()"
                              @blur="$v.passconfirm.$touch()"
                              :type="showPassConfirm ? 'text' : 'password'"
                              name="passconfirm"
                              label="Confirmar contraseña"
                              counter
                              @click:append="showPassConfirm = !showPassConfirm"
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Configuración</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="usuario.isAdmin"
                          label="Usuario administrador"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <p class="font-weight-medium">
                          Aquí puedes habilitar o deshabilitar el usuario para impedir su acceso a la aplicación
                        </p>
                        <v-btn
                          color="warning"
                          class="ma-2"
                          outlined
                          v-if="usuario.habilitado"
                          @click="usuario.habilitado = 0"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-cancel-outline
                          </v-icon>
                          Deshabilitar
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ma-2"
                          outlined
                          v-else
                          @click="usuario.habilitado = 1"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-check-outline
                          </v-icon>
                          Habilitar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> 
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogCerrar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="cerrar">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import axios from 'axios';
  import { required, minLength, email, requiredIf, sameAs } from 'vuelidate/lib/validators';
  import formatearFecha from '../../mixins/formatearFecha';
  export default {
    name: 'FullDialogUsuario',
    mixins: [formatearFecha],
    data () {
      return {
        dialogCerrar: false,
        panel: [],
        items: 5,
        resetPassword: false,
        passconfirm: '',
        showPass: false,
        showPassConfirm: false
      }
    },
    validations: {
      usuario: {
        name: { required },
        apellidos: { required },
        email: {
          required,
          email
        },
        password: {
          required: requiredIf(function(){
            return !this.editandoUsuario || this.resetPassword;
          }),
          minLength: minLength(8),
        },
      },
      passconfirm:{
        sameAsPassword: sameAs(function(){ 
          // Si no se está editando un usuario (se está creando) o se ha activado el reset de la contraseña, valido que la contraseña repetida sea igual que la contraseña
          if(!this.editandoUsuario || this.resetPassword){
            return this.usuario.password 
          }else{ // Si se está editando un usuario y no se ha activado el reset de la contraseña, no verifico el campo contraseña repetida (no existe)
            return '';
          }
        })
      },
    },
    methods: {
      ...mapActions('usuarios', ['setDialog', 'setUsuarios']),
      ...mapActions(['setLoading', 'setSnackbar']),
      avisoCerrar(){
        this.dialogCerrar = true;
      },
      cerrar(){
        this.dialogCerrar = false;
        this.setDialog(false);
        this.$v.$reset();
      },
      async guardar(){
        this.setLoading(true);
        if(this.editandoUsuario){
          axios.patch("/api/usuarios", this.usuario).then(async() => {
            let respuesta = await axios.get("/api/usuarios");
            this.setUsuarios(respuesta);
            this.setSnackbar({
              snackbar: true,
              tipo: 'success',
              mensaje: 'Usuario actualizado correctamente.'
            });
          }).catch(error => {
            console.log(error);
            this.setSnackbar({
              snackbar: true,
              tipo: 'error',
              mensaje: 'Error. No se ha podido actualizar el usuario.'
            });            
          }).finally(() => {
            this.setLoading(false);
            this.setDialog(false);
          });
        }else{
          await axios.post("api/usuarios", this.usuario).then(async() => {
            let respuesta = await axios.get("/api/usuarios");
            this.setUsuarios(respuesta);
            this.setSnackbar({
              snackbar: true,
              tipo: 'success',
              mensaje: 'Usuario creado correctamente.'
            });
          }).catch(error => {
            console.log(error);
            this.setSnackbar({
              snackbar: true,
              tipo: 'error',
              mensaje: 'Error. No se ha podido crear el usuario.'
            });            
          }).finally(() => {
            this.setLoading(false);
            this.setDialog(false);
          });
        }
      },
      setAvatar(){
        if (this.usuario.name && this.usuario.apellidos){
          this.usuario.avatar = this.usuario.name.charAt(0).toUpperCase()+this.usuario.apellidos.charAt(0).toUpperCase();
        }else{
          this.usuario.avatar = 'NU';
        }
      },
      getPosicionIdUsuario(id){
        //Devuelve la posición del array usuarios del id Usuario que se le pasa
        return this.usuarios.findIndex(x => x.id === id);
      },
    },
    computed: {
      ...mapState('usuarios', ['dialog', 'usuario', 'usuarios', 'gruposUsuario', 'editandoUsuario']),

      errorNombre () {
        if (this.$v.usuario.name.$dirty){
          if (this.$v.usuario.name.$invalid){
            return 'Introduce el nombre del usuario';
          }
        }
      },
      errorApellido () {
        if (this.$v.usuario.apellidos.$dirty){
          if (this.$v.usuario.apellidos.$invalid){
            return 'Introduce el apellido o apellidos del usuario';
          }
        }
      },
      errorEmail () {
        if (this.$v.usuario.email.$dirty){
          if(!this.$v.usuario.email.required){
            return 'Introduce el correo electrónico del usuario';
          }
          if(!this.$v.usuario.email.email){
            return 'Introduce un correo electrónico válido';
          }
        }
      },
      errorPassword () {
        if (this.$v.usuario.password.$dirty){
          if(!this.$v.usuario.password.required){
            return 'Introduce una contraseña';
          }
          if(!this.$v.usuario.password.minLength){
            return `La contraseña debe tener al menos ${this.$v.usuario.password.$params.minLength.min} carácteres`;
          }
        }
      },
      errorPassconfirm () {
        if (this.$v.passconfirm.$dirty){
          if(!this.$v.passconfirm.sameAsPassword){
            return 'Las contraseñas no coinciden';
          }
        }
      },
    },
    async created(){
      if (this.editandoUsuario){
        this.panel = [0, 1];
      }else{
        this.panel = [...Array(this.items).keys()].map((k, i) => i);
      }
    },
  }
</script>
<style>
    .anadirAsterisco label::after {
      content: " *";
      color: red;
    }
</style>